import * as actionTypes from "./actionTypes";

export const addToaster = toaster => ({
	toaster: toaster,
	type: actionTypes.ADD_TOASTER
});

export const removeToaster = id => ({
	id: id,
	type: actionTypes.REMOVE_TOASTER
});

export const addTimedToaster = (toaster, timeout = 4000) => dispatch => {
	dispatch(addToaster(toaster));
console.log("DWdw");
	// enable it for disappearing message
	if (timeout) {
		setTimeout(() => {
			dispatch(removeToaster(toaster.id));
		}, timeout);
	}
};

export const clearAll = () => ({
	type: actionTypes.CLEAR_ALL
});
